import type { ReactNode } from 'react';
import { AuthLogo } from '@/components/layout/Logo';

interface AuthShellProps {
  /** Левый блок: заголовок и сопровождающий контент. */
  leftHeading: ReactNode;
  leftBelow?: ReactNode;
  /** Правый блок: форма + всё что выше неё. */
  formHeader: ReactNode;
  children: ReactNode;
}

/**
 * Split-layout для login/register: лайм-блок слева, форма справа.
 * Соответствует .login-body / .login-container / .left-section / .form-container из main.css.
 */
export function AuthShell({ leftHeading, leftBelow, formHeader, children }: AuthShellProps) {
  const year = new Date().getFullYear();
  return (
    <div className="login-body">
      <div className="login-container">
        <div className="left-section">
          <AuthLogo />
          <h1>{leftHeading}</h1>
          {leftBelow}
          <p style={{ marginTop: 'auto' }}>© {year} Easy Fitness</p>
        </div>

        <div className="form-container">
          <div className="form-header">{formHeader}</div>
          {children}
        </div>
      </div>
    </div>
  );
}
